const init = () => {
    const protectedLogin = document.querySelector('[data-protected-login] form');
    if (protectedLogin) {
        protectedLogin.addEventListener('submit', (e) => {
            e.preventDefault();
            const passwordField = protectedLogin.querySelector('#protected-password');
            const attribute = (protectedLogin === null || protectedLogin === void 0 ? void 0 : protectedLogin.querySelector('[name="attributes[_ps]"]')) || null;
            fetch(`${window.Shopify.routes.root}cart/update.js`, {
                method: 'post',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    attributes: {
                        _ps: (attribute === null || attribute === void 0 ? void 0 : attribute.value) || null,
                    },
                }),
            })
                .then((res) => res.json())
                .then(() => {
                const checkURL = new URL(window.location.href);
                checkURL.searchParams.append('view', 'check');
                fetch(checkURL.toString())
                    .then((res) => res.json())
                    .then((data) => {
                    if (data.valid === true) {
                        passwordField.classList.remove('error');
                        window.location.reload();
                    }
                    else {
                        passwordField.classList.add('error');
                    }
                });
            });
        });
    }
};
export default init;
